import React from "react";
import PropTypes from "prop-types";

const SeeMore = ({ onClick }) => {
  return (
    <div className={`m-publications-list-more`}>
      <button className="m-publications-list-more__button" onClick={onClick}>
        <span className="m-publications-list-more__button-text">See More</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          width="16"
          height="16"
          role="img"
        >
          <path d="M14.75 7.5h-6.5V1.25h-1V7.5h-6v1h6v6.25h1V8.5h6.5v-1z" />
        </svg>
      </button>
    </div>
  );
};

SeeMore.propTypes = {
  onClick: PropTypes.func,
};

export default SeeMore;
